export default [
  {
    name: 'TagsList',
    path: '/settings/tags',
    component: () => import('pages/settings/tags/TagsList.vue')
  },
  {
    name: 'TagsCreate',
    path: '/settings/tags/new',
    component: () => import('pages/settings/tags/TagsForm.vue')
  },
  {
    name: 'TagsEdit',
    path: '/settings/tags/:id/edit',
    component: () => import('pages/settings/tags/TagsForm.vue')
  }
]
